// Plafond technique de l'ORIGINAL, avant optimisation serveur. Ce n'est pas
// le poids cible de l'image produit finale.
export const MAX_IMAGE_SIZE_MB = 25;
export const MAX_IMAGE_SIZE_BYTES = Math.floor(MAX_IMAGE_SIZE_MB * 1024 * 1024);

const ALLOWED = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/gif": [".gif"],
  "image/svg+xml": [".svg"],
  "image/avif": [".avif"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
};
export const IMAGE_ACCEPT = Object.keys(ALLOWED).join(",");

// Retourne null si le fichier est valide, sinon "type" | "size".
export const getImageFileError = (file) => {
  const name = (file?.name || "").toLowerCase();
  const exts = ALLOWED[file?.type];
  if (!exts || !exts.some((ext) => name.endsWith(ext))) return "type";
  if (file.size > MAX_IMAGE_SIZE_BYTES) return "size";
  return null;
};
